import useShopSuspense, {
  usePublicShopSuspense,
} from "@babackapp/private-api-client/client/use-shop-suspense";
import { useTemplatesEditorRouting } from "../context/templates-editor-routing-context";

export default function useCurrentShopSuspense() {
  const { shopId } = useTemplatesEditorRouting();
  return useShopSuspense(shopId);
}

export function useCurrentPublicShopSuspense() {
  const { shopId } = useTemplatesEditorRouting();
  return usePublicShopSuspense(shopId);
}
